"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ExpiredRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/ExpiredRound"));

// Generated by script, don't edit it please.
var ExpiredRound = (0, _createSvgIcon["default"])({
  as: _ExpiredRound["default"],
  ariaLabel: 'expired round',
  category: 'status',
  displayName: 'ExpiredRound'
});
var _default = ExpiredRound;
exports["default"] = _default;
module.exports = exports.default;